<template>
    <div>
        <div class="pa-3"><p1>Sandbox</p1></div>
        <v-btn color="success" @click="toast('success')">Toast Success</v-btn>
        <v-btn color="error" @click="toast('error')">Toast Error</v-btn>
        <v-btn color="info" @click="toast('info')">Toast info</v-btn>
    </div>
</template>
<script>
export default {
    name: 'sandbox',
    data () {
        return {
            toastContent: 'This is toast content'
        }
    },
    methods: {
        toast (type) {
            switch (type) {
                case 'success':
                    this.$appService.toastSuccess(this.toastContent)
                    break
                case 'error':
                    this.$appService.toastError(this.toastContent)
                    break
                case 'info':
                    this.$appService.toastInfo(this.toastContent)
                    break
            }
        }
    }
}
</script>
